import React, { useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Body from './Body';
import AboutUs from './AboutUs';
import Contact from './Contact';
import ShopByCatagories from './ShopByCatagories';
import FAQs from './FAQs';
import PrivacyPolicy from './PrivacyPolicy';
import Security from './Security';
import Blog from './Blog';
import Support from './Support';
import TermsAndConditions from './TermsAndConditions';
import Testimonials from './Testimonials';
import SmartSystems from './SmartSystems';
import ElectronicsTrading from './ElectronicsTrading';
import Innovative from "./Innovative";
import GiftCardsAndValueAddedServices from './GiftCardsAndValueAddedServices';
import CallCentersEmpowerment from './CallCentersEmpowerment';
import SIMRegistrationAndGSMCards from './SIMRegistrationAndGSMCards';
import NetworkingServices from './NetworkingServices';

const Home = () => {
  const appRouter = createBrowserRouter([
    { path: '/', element: <Body /> },
    { path: '/about-us', element: <AboutUs /> },
    { path: '/contact-us', element: <Contact /> },
    { path: '/shop-by-catagories', element: <ShopByCatagories /> },
    { path: '/faqs', element: <FAQs /> },
    { path: '/privacy', element: <PrivacyPolicy /> },
    { path: '/security', element: <Security /> },
    { path: '/blog', element: <Blog /> },
    { path: '/support', element: <Support /> },
    { path: '/terms', element: <TermsAndConditions /> },
    { path: '/testimonials', element: <Testimonials /> },
    { path: '/smartsystems', element: <SmartSystems /> },
    { path: '/electronics-trading', element: <ElectronicsTrading /> }, 
    { path: '/innovative', element: <Innovative /> },
    { path: '/Gift&value', element: <GiftCardsAndValueAddedServices /> },
    { path: '/callcenter', element: <CallCentersEmpowerment /> },
    { path: '/sim-registration', element: <SIMRegistrationAndGSMCards /> },
    { path: '/networking', element: <NetworkingServices /> }
  ]);

  // Scroll to the top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <RouterProvider router={appRouter} />
  );
}

export default Home;
